import { CarlineWithOfertas } from '../services/ofertas-service/models/ofertas';

export const addCarlineInPath = (activeCarlineIndex: number, carlines: CarlineWithOfertas[]): void => {
	if (activeCarlineIndex >= 0 && window.location?.pathname && window.history?.replaceState) {
		const search = window.location.search;
		const splittedPath = window.location.pathname.split('/');

		const existingIndex = splittedPath.findIndex((path) => path.includes('__app'));

		if (existingIndex >= 0) {
			splittedPath.splice(existingIndex);
		}

		splittedPath.push(`__app/${carlines[activeCarlineIndex].name}.app`);

		const finalPath = splittedPath.join('/');
		window.history.replaceState(null, '', `${finalPath}${search}`);
	}
};

export const cleanCarlineInPath = (): void => {
	if (window.location?.pathname && window.history?.replaceState) {
		const search = window.location.search;
		const splittedPath = window.location.pathname.split('/');
		const index = splittedPath.findIndex((path) => path.includes('__app'));

		if (index >= 1) {
			splittedPath.splice(index);
			const finalPath = splittedPath.join('/');
			window.history.replaceState(null, '', `${finalPath}${search}`);
		}
	}
};

export const hasCarlineInPath = (carlines: CarlineWithOfertas[]): boolean => {
	if (!window.location?.pathname) return false;

	const splittedPath = window.location.pathname.split('/');
	return carlines.some((carline) => splittedPath.some((path) => path.replace('.app', '') === carline.name));
};
